import { render } from "./ArtikelPage.vue?vue&type=template&id=3e936c12&scoped=true"
import script from "./ArtikelPage.vue?vue&type=script&lang=js"
export * from "./ArtikelPage.vue?vue&type=script&lang=js"

import "./ArtikelPage.vue?vue&type=style&index=0&id=3e936c12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e936c12"]])

export default __exports__